export const PageFeatureFlags = {
  ShowCanadaPostBanner: 'show-canada-post-banner',
  ShowGroceryContestBanner: 'show-grocery-contest-banner',
} as const;
